import React from 'react';
import { Focusable, Icon } from '..';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export function AddSubjectCard({ onPress, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [styles.addSubjectWrapper, style], onPress: onPress },
        React.createElement(Icon, { name: 'add', size: 21, color: (color) => color.primary.solid }),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'semibold', style: styles.addSubjectText }, "Add Subject")));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    addSubjectWrapper: {
        minWidth: 300,
        minHeight: 80,
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: size.H,
        borderWidth: 2,
        borderColor: color.invert2.p4,
        borderStyle: 'dashed',
        padding: size.G
    },
    addSubjectText: { marginLeft: size.B, color: color.primary.solid }
}));
//# sourceMappingURL=AddSubjectCard.js.map